<template>
  <div>
    <el-row>
      <CoreTableContainer
        :columns="containerTableColumns"
        :serverUrl="containerServerUrl"
        :baseUrl="containerBaseUrl"
        :tableToolConfig="tableToolConfig"
        :FilterStatusDefault="false"        
        :fromschedulingreview="true"
        ref="CoreTableContainer"
      >
        <template v-slot:columnSlotTool="{props}">
            <el-button type="primary" size="small" @click="onPreviewDetail(props)">查看详细</el-button>
        </template>

        <template v-slot:filter>
          <PartyOrgCascader @onValueChanged="onPidChanged" v-if="isjdx || isAdmin || isPartyManager"></PartyOrgCascader>
          <UnitCascader @onValueChanged="onUnitidChanged"  v-if="isjdx || isAdmin || isUnitManager"></UnitCascader>
        </template>

        <!--  -->
        <template v-slot:table__footer__info>学时信息列表</template>
      </CoreTableContainer>

    </el-row>
  </div>
</template>




<script>
import { StudyClassSelect } from "@/views/components/select";
import { PartyOrgCascader,UnitCascader } from "@/views/components/select"
import { CoreTableContainer } from "@/core/table"

export default {
  name: "study-class-hours",
  props:{
    timetype:{
      type: Number
    }
  },
  components: {
    CoreTableContainer,
    StudyClassSelect,
    UnitCascader,
    PartyOrgCascader
  },
  data() {
    return {
      fromWhere : "studyclassHours",
      containerTableColumns: [
        {
          prop: "title",
          label: "学习班",
        },
        {
          prop: "cdate",
          label: "学习班创建时间",
          width : "200"
        },
        {
          prop: "type",
          label: "类型",
          convert : (type)=>{
            return type? '单位课程':'党组织生活';
          },
          width : "100"
        },
        {
          prop: "createName",
          label: "开班单位/党组织",
          width : "350"

        }
      ],
      // 基础地址
      containerBaseUrl : "/export",
      // api的基础地址
      // eslint-disable-next-line no-undef
      containerServerUrl : "/api/manager/studyClassReport",

      tableToolConfig: {
        canRecover : false,
        canEdit : false,
        canDelete : false,
        canDisable : false,
      },

      isjdx: null,
      isAdmin : null,
      roleid : null,
      isPartyManager: null,
      isUnitManager : null
  
    }
  },
  methods :{
    onStudyClassValueChanged(sid) {
      this.$refs.CoreTableContainer.updateSid(sid);
    },

    onPidChanged(pids){
      this.$refs.CoreTableContainer.updateParams("pids",pids);
    },
    onUnitidChanged(unitids){
      this.$refs.CoreTableContainer.updateParams("unitids",unitids);
    },

    onPreviewDetail(id){      
      let url = '/export/studyclassHours/studyclassHoursDetail'
      this.$router.push({
        path : url,
        query : {
          id
        }
      })
    }
  },

  created(){
    this.isAdmin = this.$store.getters['profileModule/isadmin'];
    this.isPartyManager = this.$store.getters['profileModule/isPartyManager'];
    this.isUnitManager = this.$store.getters['profileModule/isUnitManager'];
    this.isjdx = this.$store.getters['profileModule/isjdx'];
  }
}


</script>




<style scoped>
</style>